export const apiQuickReferenceMarkdown = `# API Quick Reference

This is a simplified high-value endpoint list for ERP integrations.

Use Swagger for complete schema and all available endpoints.

## System

- \`GET /api/health\` - API health status

## Authentication

- \`POST /api/auth/login\` - authenticate and receive JWT
- \`GET /api/auth/me\` - current authenticated user profile
- \`GET /api/auth/companies\` - list companies user can access
- \`POST /api/auth/switch-company\` - issue token scoped to selected company

## Companies

- \`GET /api/companies\` - list companies
- \`GET /api/companies/{id}\` - get company details
- \`PUT /api/companies/{id}\` - update company configuration

## Employees

- \`GET /api/employees?companyId={companyId}\` - list employees by company
- \`GET /api/employees/{id}\` - get employee
- \`POST /api/employees\` - create employee
- \`PUT /api/employees/{id}\` - update employee
- \`DELETE /api/employees/{id}\` - delete employee

## Payroll run lifecycle

- \`GET /api/payroll?companyId={companyId}\` - list payroll runs
- \`GET /api/payroll/{id}\` - get payroll run
- \`POST /api/payroll\` - create payroll run
- \`PUT /api/payroll/{id}\` - update payroll run
- \`POST /api/payroll/{id}/process\` - process payroll
- \`POST /api/payroll/{id}/recalculate\` - recalculate payroll
- \`POST /api/payroll/{id}/approve\` - approve payroll
- \`POST /api/payroll/{id}/finalize\` - finalize payroll
- \`POST /api/payroll/{id}/cancel\` - cancel payroll

## Payroll outputs and analytics

- \`GET /api/payroll/{id}/accounting-breakdown\`
- \`GET /api/payroll/{id}/employee/{employeeId}/breakdown\`
- \`GET /api/employees/{id}/ytd-earnings\`
- \`GET /api/employees/{id}/tax-history\`
- \`GET /api/employees/{id}/pay-history\`

## Cimmple ERP accounting integration

- \`GET /api/payroll/{id}/erp-journal-preview\`
- \`POST /api/payroll/{id}/erp-journal/sync\`

## Standard response codes

- \`200\` / \`201\` - success
- \`204\` - success, no content
- \`400\` - validation or business rule error
- \`401\` - unauthorized
- \`403\` - forbidden
- \`404\` - not found
- \`500\` - unexpected server error
`;
